import { render } from "./LocationDetailsPopover.vue?vue&type=template&id=3a38a285&ts=true"
import script from "./LocationDetailsPopover.vue?vue&type=script&lang=ts"
export * from "./LocationDetailsPopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__